'use strict';

class productService {
  constructor($http) {
    this.$http = $http;
  }

  list(query) {
    return this.$http.get('/products/', {
      params: {
        query: query
      }
    });
  }

  listWarehouse(query) {
    return this.$http.get('/products/warehouse', {
      params: {
        query: query
      }
    });
  }

  removeFromWarehouse(number) {
    return this.$http.put('/products/warehouse/' + number + '/remove');
  }

  addToWarehouse(number) {
    return this.$http.put('/products/warehouse/' + number + '/add');
  }

  updateQuantities(products) {
    return this.$http.put('/products/warehouse', products);
  }

  search(q) {
    return this.$http.get('/products/?productCode=' + encodeURI(q));
  }

  get(number) {
    return this.$http.get('/products/' + number);
  }

  save(params) {
    return this.$http.post('/products/', params);
  }

  update(params) {
    return this.$http.put('/products/' + params.number, params);
  }

  updateWarehouse(params) {
    return this.$http.put('/products/warehouse', params);
  }

  updateWithRecurring(params) {
    return this.$http.put('/products/withRecurring/' + params.number, params);
  }

  remove(number) {
    return this.$http.delete('/products/' + number);
  }
}

productService.$inject = ['$http'];

angular
  .module('SendRegning')
  .service('productService', productService);
